
import { useStore } from '@xyflow/react'

export type LODTier = 'full' | 'reduced' | 'minimal' | 'ultra'

const LOD_THRESHOLDS = {
  FULL: 0.6,
  REDUCED: 0.35,
  MINIMAL: 0.15,
}

/**
 * Subscribes to React Flow zoom level and returns a discrete LOD tier.
 *
 * - full    (zoom >= 0.6)  — all details rendered
 * - reduced (zoom >= 0.35) — no shadows, transitions, or animations
 * - minimal (zoom >= 0.15) — node content hidden, plain rectangles
 * - ultra   (zoom < 0.15)  — simple colored divs, handles hidden, 80%+ DOM reduction
 *
 * Tier is computed inside the store selector so the component only
 * re-renders when the tier actually changes (not on every zoom frame).
 *
 * Must be used inside <ReactFlow> (needs the internal store).
 */
export function useZoomLOD(): { tier: LODTier } {
  const tier = useStore((s): LODTier => {
    const z = s.transform[2]
    if (z >= LOD_THRESHOLDS.FULL) return 'full'
    if (z >= LOD_THRESHOLDS.REDUCED) return 'reduced'
    if (z >= LOD_THRESHOLDS.MINIMAL) return 'minimal'
    return 'ultra'
  })

  return { tier }
}
